import {
  PackageStatusOption,
  PackageExceptionOption,
} from "pages/partview/utils/filter.utils";

export const partViewPackageStatusOnClick = (
  _ignoredQueryKey,
  filterValue,
  clearSearchFilters,
  setSearchFilter,
  searchEntities,
  past24hrs = { fromDate: undefined, toDate: undefined },
) => {
  clearSearchFilters();

  if (filterValue === "Created/Packaged") {
    setSearchFilter("lifecycleState", [
      PackageStatusOption.CREATED_OR_PACKAGED,
    ]);
  }

  if (filterValue === "In Route") {
    setSearchFilter("lifecycleState", [PackageStatusOption.IN_ROUTE]);
  }

  if (filterValue === "Delayed") {
    setSearchFilter("lifecycleState", [PackageStatusOption.DELAYED]);
  }

  if (filterValue === "Available for Pickup") {
    setSearchFilter("lifecycleState", [
      PackageStatusOption.AVAILABLE_FOR_PICKUP,
    ]);
  }

  if (filterValue === "Delivered") {
    setSearchFilter("lifecycleState", [PackageStatusOption.DELIVERED]);
    setSearchFilter("deliveryDate", {
      from: past24hrs.fromDate,
      to: past24hrs.toDate,
      dateType: ["actual"],
    });
  }

  searchEntities();
};

export const partViewPackageExceptionOnClick = (
  filterValue,
  selectedActiveFilterOptions,
  clearSearchFilters,
  setSearchFilter,
  searchEntities,
  isDealer = false,
) => {
  let exceptionMap = {
    Short: PackageExceptionOption.SHORT,
    Held: PackageExceptionOption.HELD,
    Misrouted: PackageExceptionOption.MISROUTED,
    Backorder: PackageExceptionOption.BACKORDER,
    Missing: PackageExceptionOption.MISSING,
    Lost: PackageExceptionOption.LOST,
    "Missing Scan Event": PackageExceptionOption.MISSING_SCAN_EVENT,
    Recycled: PackageExceptionOption.RECYCLED,
  };
  //Remove Damage exception for dealer from selected options in the active exception filter options
  if (!isDealer) {
    exceptionMap["Damaged"] = PackageExceptionOption.DAMAGED;
  }

  clearSearchFilters();
  const exception = filterValue
    ? [exceptionMap[filterValue]]
    : Object.values(exceptionMap);
  if (exception) {
    setSearchFilter("lifecycleState", selectedActiveFilterOptions);
    setSearchFilter("exception", exception);
  }

  searchEntities();
};
